import { z } from 'zod/v4';

export const CollaborationStatusesListSortColumns = [
  'name',
  'createdAt',
  'updatedAt',
] as const;

export type CollaborationStatusesListSortColumn =
  (typeof CollaborationStatusesListSortColumns)[number];

const sortColumns = CollaborationStatusesListSortColumns.join('|');

// One or more comma-separated `<column>:<ASC|DESC>` terms, e.g.
// `name:DESC,createdAt:ASC` — the same grammar the legacy route accepted.
const sortPattern = new RegExp(
  `^(${sortColumns}):(ASC|DESC)(,(${sortColumns}):(ASC|DESC))*$`,
);

export const CollaborationStatusesListQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  sort: z.string().regex(sortPattern).optional(),
  // JSON object; only `name` is honoured (case-insensitive substring match).
  filter: z.string().max(512).optional(),
});

export type CollaborationStatusesListQuery = z.infer<
  typeof CollaborationStatusesListQuerySchema
>;

// Trimmed to the `id`/`name` every caller reads; legacy also returned the
// `created_by_*` / `updated_by_*` audit columns.
export const CollaborationStatusRowSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type CollaborationStatusRow = z.infer<
  typeof CollaborationStatusRowSchema
>;

// The platform's paginated envelope. `pagination.page` is 1-based, unlike the
// 0-based `page` query param.
export const CollaborationStatusesListResponseSchema = z.object({
  metadata: z.object({
    success: z.boolean(),
    pagination: z.object({
      page: z.number(),
      limit: z.number(),
      total: z.number(),
      totalPages: z.number(),
    }),
  }),
  data: z.array(CollaborationStatusRowSchema),
});

export type CollaborationStatusesListResponse = z.infer<
  typeof CollaborationStatusesListResponseSchema
>;
